"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { useReducer, useEffect } from 'react';

function resolvePromise(promise) {
  if (typeof promise === "function") {
    return promise();
  }
  return promise;
}
const states = {
  pending: "pending",
  rejected: "rejected",
  resolved: "resolved"
};
const defaultState = {
  error: void 0,
  result: void 0,
  state: states.pending
};
function reducer(state, action) {
  switch (action.type) {
    case states.pending:
      return defaultState;
    case states.resolved:
      return {
        error: void 0,
        result: action.payload,
        state: states.resolved
      };
    case states.rejected:
      return {
        error: action.payload,
        result: void 0,
        state: states.rejected
      };
    default:
      return state;
  }
}
function usePromise(promise, inputs) {
  const [{ error, result, state }, dispatch] = useReducer(reducer, defaultState);
  useEffect(
    () => {
      const resolvedPromise = resolvePromise(promise);
      if (!resolvedPromise) {
        return;
      }
      let canceled = false;
      dispatch({ type: states.pending });
      resolvedPromise.then(
        (result2) => !canceled && dispatch({
          payload: result2,
          type: states.resolved
        }),
        (error2) => !canceled && dispatch({
          payload: error2,
          type: states.rejected
        })
      );
      return () => {
        canceled = true;
      };
    },
    inputs ?? [promise]
  );
  return [result, error, state];
}

export { usePromise };
